export const teresaQuotes = {
  initial: {
    id: 0,
    lines: [
      "We have been observing you.",
      "You have shown promise with your bending of Reality.",
      "We are the Celestials, and we want you to join us.",
      "My name is Teresa, the Celestial Of Reality.",
      "Prove your worth.",
    ]
  },
  unlockReality: {
    id: 1,
    lines: [
      "I will let you inside my Reality, mortal. Do not get crushed by it."
    ]
  },
  completeReality: {
    id: 2,
    lines: [
      "Why are you still here... you were supposed to fail."
    ]
  },
  effarig: {
    id: 3,
    lines: [
      "You are still no match for us.",
      "I hope the others succeed where I have failed."
    ]
  },
  IntroOuter: {
    id: 4,
    lines: [
      "When you are near me, I have a feeling of....déjà vu",
      "Did we meet already ?",
      "I don't think so 'cause I would have crushed you already",
      "But I don't care",
      "You can try if you want"
    ]
  },
  OuterTeresa: {
    id: 5,
    lines: [
      "Where are we ?",
      "How did you get here ?",
      "I feel like...I am near my..true? self",
      "But I am here, How is it even posible ?",
      "I...I need some time but thank you to make me discover this. I feel like it's very important"
    ]
  },
  Outereffarig: {
    id: 6,
    lines: [
      "Help them too",
      "Please"
    ]
  },
  TrialsOuter: {
    id: 7,
    lines: [
      "Ho...You, again",
      "Am I the last one ?",
      "Did they suffer ?",
      "How is it possible ?",
      "What is beyond us ?",
      "You want my power isn't it ?",
      ""
    ]
  }
};
